/* eslint-disable react/no-children-prop */
import React from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import AuthRoute from "../components/AuthRoute";
import routes from "./Routes";
import NoMatch from "../components/NoMatch";
import {
  isMaintenanceModeEnabled,
  isRouteWhitelisted,
  maintenanceConfig,
} from "../config/maintenance.config";

const MaintenanceWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();
  const maintenanceMode = isMaintenanceModeEnabled();

  if (maintenanceMode) {
    const isWhitelisted = isRouteWhitelisted(
      location.pathname,
      maintenanceConfig.whitelistedRoutes
    );

    if (!isWhitelisted) {
      return <Navigate to="/maintenance" replace />;
    }
  }

  return <>{children}</>;
};

const RouteCombiner = () => {
  return (
    <MaintenanceWrapper>
      <Routes>
        {routes.map((route, index) => {
          return (
            <Route
              key={index}
              path={route.path}
              element={
                <AuthRoute key={index} path={route.path}>
                  {route.Layout ? (
                    <route.Layout children={<route.Layout />} />
                  ) : (
                    <route.Component />
                  )}
                </AuthRoute>
              }
            >
              {route.modules &&
                route.modules.map((page: any) => (
                  <Route
                    key={index}
                    path={page.path}
                    element={<page.Component />}
                  />
                ))}
            </Route>
          );
        })}
        <Route path="*" element={<NoMatch />} />
      </Routes>
    </MaintenanceWrapper>
  );
};

export default RouteCombiner;
